import { render, staticRenderFns } from "./paramet01.vue?vue&type=template&id=236a86fd&scoped=true&"
import script from "./paramet01.vue?vue&type=script&lang=js&"
export * from "./paramet01.vue?vue&type=script&lang=js&"
import style0 from "./paramet01.vue?vue&type=style&index=0&id=236a86fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a86fd",
  null
  
)

export default component.exports